import React from 'react';

export default function GovLogo({ size = 40, className = '' }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/bd-gov-logo.png`}
      alt="Government of Bangladesh"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain', flexShrink: 0 }}
      data-testid="gov-logo"
    />
  );
}
